import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'
import SelectPartnerSewing from '../../../update-batches/components/SelectPartnerSewing'

// Ô đối tác nằm ở đáy màn → mặc định bung danh sách lên trên; vẫn giữ overflow.adjustY của antd
// nên phía trên không đủ chỗ thì tự lật xuống.
const DROPDOWN_ALIGN_TOP = { points: ['bl', 'tl'], offset: [0, -4] }

// Thanh dưới ghim: chọn đối tác, tổng lô/item hợp lệ, link nhảy tới dòng lỗi / lý do chưa giao / "Sẵn sàng giao", nút Giao may
const BottomBar = ({
    partner, partnerInvalid, totalBatches, totalItems, issueCount, issuePosition, canSubmit, submitting, hint,
    onChangePartner, onPartnersLoaded, onJumpToIssue, onSubmit,
}) => (
    <div className="HandoverBottomBar">
        <SelectPartnerSewing
            partner={partner}
            onChangePartner={onChangePartner}
            onLoaded={onPartnersLoaded}
            searchByCode
            invalid={partnerInvalid}
            hideLabel
            size="large"
            placeholder="Chọn đối tác may (gõ để tìm)…"
            notFoundContent="Không tìm thấy đối tác"
            className="HandoverBottomBar-partner"
            dropdownClassName="custom-select-partner HandoverPartnerDropdown"
            dropdownAlign={DROPDOWN_ALIGN_TOP}
        />
        <div className="HandoverBottomBar-row">
            <div className="HandoverBottomBar-summary">
                <div><b>{totalBatches}</b> lô · <b>{totalItems}</b> item hợp lệ</div>
                {issueCount > 0
                    ? (
                        <button type="button" className="HandoverBottomBar-issues" onClick={onJumpToIssue}>
                            ⚠ {issueCount} dòng cần xử lý{issuePosition > 0 ? ` · ${issuePosition}/${issueCount}` : ''} ›
                        </button>
                    )
                    : (hint && <small>{hint}</small>)
                    || (canSubmit && <small className="HandoverBottomBar-ready">✓ Sẵn sàng giao</small>)}
            </div>
            <Button
                type="primary"
                size="large"
                className="HandoverBottomBar-submit"
                disabled={!canSubmit}
                loading={submitting}
                onClick={onSubmit}
            >
                Giao may
            </Button>
        </div>
    </div>
)

BottomBar.propTypes = {
    partner: PropTypes.string,
    partnerInvalid: PropTypes.bool,
    totalBatches: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired,
    issueCount: PropTypes.number,
    // Thứ tự dòng cần xử lý vừa nhảy tới (1..issueCount), 0 = chưa nhảy
    issuePosition: PropTypes.number,
    canSubmit: PropTypes.bool.isRequired,
    submitting: PropTypes.bool,
    hint: PropTypes.string,
    onChangePartner: PropTypes.func.isRequired,
    onPartnersLoaded: PropTypes.func,
    onJumpToIssue: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
}

BottomBar.defaultProps = {
    partner: '',
    partnerInvalid: false,
    issueCount: 0,
    issuePosition: 0,
    submitting: false,
    hint: '',
    onPartnersLoaded: () => {},
}

export default BottomBar
